import { render, staticRenderFns } from "./MedicalCoverage.vue?vue&type=template&id=eee344f0"
import script from "./MedicalCoverage.vue?vue&type=script&lang=js"
export * from "./MedicalCoverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports